<mat-toolbar color="secondary" class="flexSpaceBetween">
  <div style="display:flex; gap: 100px; align-items:center;">
    <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon"
      (click)="onToggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div *ngIf="0" style="width:500px;" >
    <mat-form-field style="width:100%;height:30px;" appearance="outline" >
      <mat-icon>search</mat-icon>
      <input 
        matInput 
        [(ngModel)]="rekbotSearch" 
        placeholder="Wyszukaj swojego Rekbot'a...">
  </mat-form-field>
  </div>

  <!-- Tree - Prawa strona -->
  <div class="header-right">
    <div class="tree">
      <img src="assets/img/flag.png" alt="Flaga" />
      <span>Polski</span>
      <img src="assets/img/arrow-down-sign-to-navigate.png" alt="Strzałka" class="arrow-icon" />
    </div>
    <div class="tree">
      <button mat-stroked-button class="p-0 m-0 profile-btn" [matMenuTriggerFor]="profilMenu">
        <img src="assets/img/user.png" alt="Użytkownik" />
        <span>Profil</span>
      </button>
    </div>
  </div>

</mat-toolbar>

<mat-menu class="profile-menu" #profilMenu="matMenu">
      <button mat-menu-item (click)="openUserProfile()"><mat-icon>settings</mat-icon>
        Ustawienia</button>
      <button mat-menu-item *ngIf="isAuthenticated()" (click)="logout()">
        <mat-icon>exit_to_app</mat-icon>
        Wyloguj się
      </button>
  </mat-menu>